"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var page_buttons_1 = require("../../../../components/pricing/layout/page-buttons/page-buttons");

var page_connected_1 = require("../../../../components/pricing/layout/page/page.connected");

var price_lookup_page_content_1 = require("../../../../theming/pricing-system/price-lookup-page.content");

var drug_search_help_dialog_1 = require("../../dialogs/drug-search-help-dialog/drug-search-help-dialog");

var select_group_message_1 = require("../../messages/select-group-message/select-group-message");

var price_lookup_drug_info_panel_connected_1 = require("../../panels/price-lookup-drug-info-panel/price-lookup-drug-info-panel.connected");

var price_lookup_input_panel_1 = require("../../panels/price-lookup-input-panel/price-lookup-input-panel");

var price_lookup_results_panel_connected_1 = require("../../panels/price-lookup-results-panel/price-lookup-results-panel.connected");

var pricing_experience_navigator_screen_names_1 = require("../../pricing-experience-navigator/pricing-experience-navigator.screen-names");

var pageViewStyle = {
  marginLeft: 'auto',
  marginRight: 'auto',
  maxWidth: '40rem'
};
var lookupButtonsViewStyle = {
  marginBottom: '1rem',
  marginTop: '-1rem',
  width: '100%'
};

var PriceLookupPage = function (_super) {
  __extends(PriceLookupPage, _super);

  function PriceLookupPage() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {};
    _this.priceLookupInputPanelRef = react_1.default.createRef();
    _this.pageRef = react_1.default.createRef();

    _this.onPriceLookupInputChange = function (panelChangeInfo) {
      _this.priceReset();

      var currentAttributes = _this.state.drugAttributes;
      var currentNdc = currentAttributes ? currentAttributes.drugNdc : undefined;

      _this.setState({
        drugAttributes: panelChangeInfo
      });

      var drugGet = _this.props.drugGet;

      if (panelChangeInfo.drugNdc !== currentNdc && drugGet) {
        drugGet(panelChangeInfo.drugNdc);
      }
    };

    _this.onSubmitButtonPress = function () {
      var priceLookupInfoPanelRef = _this.priceLookupInputPanelRef.current;
      var changeInfo;

      if (priceLookupInfoPanelRef) {
        changeInfo = priceLookupInfoPanelRef.validate();
      }

      if (!changeInfo) {
        return;
      }

      _this.lookupByNdc(changeInfo);
    };

    _this.lookupByNdc = function (changeInfo) {
      var ndc = changeInfo.drugNdc;
      var daysSupply = changeInfo.daysSupply;
      var quantity = changeInfo.quantity;

      if (!ndc || !daysSupply || !quantity) {
        return;
      }

      var lookupInfo = {
        daysSupply: daysSupply,
        ndc: ndc,
        quantity: quantity
      };
      var priceLookupByNdc = _this.props.priceLookupByNdc;

      if (priceLookupByNdc) {
        priceLookupByNdc(lookupInfo);
      }
    };

    _this.onResetButtonPress = function () {
      _this.priceReset();

      _this.drugReset();

      var priceLookupInputPanelRef = _this.priceLookupInputPanelRef.current;

      if (priceLookupInputPanelRef) {
        priceLookupInputPanelRef.clear();
        priceLookupInputPanelRef.focus();
      }
    };

    _this.drugReset = function () {
      _this.setState({
        drugAttributes: undefined
      });

      if (_this.props.drugGet) {
        _this.props.drugGet(undefined);
      }
    };

    _this.priceReset = function () {
      var priceReset = _this.props.priceReset;

      if (priceReset) {
        priceReset();
      }
    };

    _this.onShowDrugSearchHelpDialog = function () {
      _this.setState({
        showDrugSearchHelpDialog: true
      });
    };

    _this.onCloseDrugSearchHelpDialog = function () {
      _this.setState({
        showDrugSearchHelpDialog: false
      });
    };

    return _this;
  }

  PriceLookupPage.prototype.componentDidUpdate = function () {
    var pageRef = this.pageRef.current;

    if (this.props.isPriceLookupInProgress && pageRef) {
      pageRef.scrollToBottom();
    }
  };

  PriceLookupPage.prototype.render = function () {
    return react_1.default.createElement(page_connected_1.PageConnected, {
      ref: this.pageRef,
      title: this.title,
      selectedTabValue: pricing_experience_navigator_screen_names_1.NavigationScreenNames.priceLookupPage,
      showPharmacyGroup: true,
      isAdmin: this.props.isAdmin,
      viewStyle: pageViewStyle
    }, this.renderPageContent());
  };

  Object.defineProperty(PriceLookupPage.prototype, "title", {
    get: function get() {
      return this.props.isAdmin ? price_lookup_page_content_1.PriceLookupPageContent.titleForAdmin : price_lookup_page_content_1.PriceLookupPageContent.titleForPharmacy;
    },
    enumerable: true,
    configurable: true
  });

  PriceLookupPage.prototype.renderPageContent = function () {
    if (!this.props.currentGroup) {
      return react_1.default.createElement(select_group_message_1.SelectGroupMessage, null);
    }

    return this.renderPanels();
  };

  PriceLookupPage.prototype.renderPanels = function () {
    var lookupButtons = [{
      onPress: this.onSubmitButtonPress,
      text: price_lookup_page_content_1.PriceLookupPageContent.submitButton
    }, {
      onPress: this.onResetButtonPress,
      text: price_lookup_page_content_1.PriceLookupPageContent.resetButton,
      type: 'secondary'
    }];
    return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(price_lookup_input_panel_1.PriceLookupInputPanel, {
      ref: this.priceLookupInputPanelRef,
      onChange: this.onPriceLookupInputChange,
      onDrugSearchHelpDialogShow: this.onShowDrugSearchHelpDialog,
      isDisabled: this.state.showDrugSearchHelpDialog
    }), this.renderDrugSearchHelpDialog(), react_1.default.createElement(page_buttons_1.PageButtons, {
      buttons: lookupButtons,
      viewStyle: lookupButtonsViewStyle
    }), this.renderDrugInfoPanel(), this.renderResultsPanel());
  };

  PriceLookupPage.prototype.renderDrugInfoPanel = function () {
    if (!this.props.isDrugSelected) {
      return null;
    }

    return react_1.default.createElement(price_lookup_drug_info_panel_connected_1.PriceLookupDrugInfoPanelConnected, null);
  };

  PriceLookupPage.prototype.renderResultsPanel = function () {
    if (!this.props.isDrugSelected) {
      return null;
    }

    return react_1.default.createElement(price_lookup_results_panel_connected_1.PriceLookupResultsPanelConnected, null);
  };

  PriceLookupPage.prototype.renderDrugSearchHelpDialog = function () {
    if (!this.state.showDrugSearchHelpDialog) {
      return null;
    }

    var widthInRem = 35;
    var viewStyle = {
      alignSelf: 'center',
      maxWidth: widthInRem + "rem",
      position: 'absolute',
      top: '50%'
    };
    return react_1.default.createElement(drug_search_help_dialog_1.DrugSearchHelpDialog, {
      viewStyle: viewStyle,
      onClose: this.onCloseDrugSearchHelpDialog
    });
  };

  return PriceLookupPage;
}(react_1.default.Component);

exports.PriceLookupPage = PriceLookupPage;